import { getImageFields } from '@utils';
import { IMG_TYPES } from '@atoms/Img';

export default ({ filled, outlined, ctaLabel, productCategories }) => ({
  marquee: {
    filled,
    outlined,
  },
  ctaLabel,
  productCategories: productCategories.map(({ id, slug, name, products }) => ({
    id,
    category: {
      name,
      slug,
    },
    products: products.map(
      ({
        productId,
        flavour,
        color,
        proteinGramage,
        productPicture,
        productSlug,
        priority,
      }) => ({
        id: productId,
        flavour,
        color,
        proteinGramage,
        priority: priority || 0,
        slug: productSlug,
        image: getImageFields(productPicture, IMG_TYPES.fixed),
      })
    ),
  })),
});
